<template>
  <div v-if="dashboard_data.total_sales!=null">
    <WidgetsDropdown :info="dashboard_data"/>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            رزرو ها
          </CCardHeader>
          <CCardBody>

            <br/>
            <CDataTableFixed
                class="mb-0 table-outline"
                hover
                striped

                :items="dashboard_data.last_orders"
                :fields="orderFields"
                head-color="light"
                no-sorting
            >


              <template #line="{item}">
                <td>
                  <div class="clearfix">
                    <div class="float-left">
                      <strong>{{ item.line.title }}
                      {{item.admin.name}}</strong>
                    </div>
                  </div>
                </td>

              </template>

              <template #created_at="{item}">
                <td>
                  <p>{{ get_date_time(item.reserve_time.date) }}</p>
                </td>
              </template>
              <template #table_id="{item}">
                <td>
                  <p>{{ (item.table.title) }}</p>
                </td>
              </template>
              <template #name="{item}">
                <td>
                  <p>{{ item.user.name }}</p>
                </td>
              </template>
              <template #total_price="{item}">
                <td>
                  <p>{{ get_currency(item.total_price) }}</p>
                </td>
              </template>

              <template #operation="{item}">
                <td>
                  <CButton
                      color="info"
                      @click="$router.push('/dashboard/orders/info/'+item.id)"
                  >
                    <CIcon name="eye"/>
                  </CButton>
                </td>

              </template>

            </CDataTableFixed>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CCard>
      <CCardBody>
        <CRow>
          <CCol col="5">
            <h4 id="traffic" class="card-title mb-0">نمودار رزرو</h4>
          </CCol>
          <CCol col="7" class="d-none d-md-block">

            <CButtonGroup class="float-right mr-3">
              <CButton
                  color="outline-secondary"
                  v-for="(value, key) in ['روزانه', 'ماهانه', 'سالانه']"
                  :key="key"
                  class="mx-0"
                  :pressed="value === selected_sale_time ? true : false"
                  @click="selected_sale_time = value"
              >
                {{ value }}
              </CButton>
            </CButtonGroup>
          </CCol>
        </CRow>
        <NewChartJs
            v-if="dashboard_data.dashboard_daily_report"
            type="bar"
            label="فروش"
            :info="dashboard_data.dashboard_daily_report"
            style="height:300px;margin-top:40px;"/>

      </CCardBody>

    </CCard>
    <!--    <WidgetsBrand/>-->
  </div>
</template>

<script>
import MainChartExample from './charts/MainChartExample'
import WidgetsDropdown from './widgets/WidgetsDropdown'
import WidgetsBrand from './widgets/WidgetsBrand'
import axios from "axios";
import NewChartJs from "@/views/charts/NewChartJs.vue";

export default {
  name: 'Dashboard',
  components: {
    MainChartExample,
    WidgetsDropdown,
    WidgetsBrand,
    NewChartJs
  },
  data() {
    return {
      selected_sale_time: 'روزانه',
      selected_products_time: 'روزانه',

      userFields: [
        {key: 'id', label: '#', _classes: 'text-center'},
        {key: 'name', label: 'نام و نام خانودگی'},
        {key: 'created_at', label: 'تاریخ ثبت نام', _classes: 'text-center'},
        {key: 'phone', label: 'شماره همراه', _classes: 'text-center'},
        {key: 'orders_count', label: 'تعداد سفارش', _classes: 'text-center'},
        {key: 'operation', label: 'عملیات'},
      ],
      orderFields: [
        {key: 'id', label: '#', _classes: 'text-center'},
        {key: 'name', label: 'مشتری'},
        {key: 'created_at', label: 'تاریخ ثبت', _classes: 'text-center'},
        {key: 'line', label: 'لاین', _classes: 'text-center'},
        // {key: 'operation', label: 'عملیات'},
      ],
      dashboard_data: {},
    }
  },
  mounted() {
    this.get_dashboard_data();
  },
  methods: {
    goCustomerOrders(item) {
      this.$router.push({path: '/dashboard/orders/list/'+item.id});
    },
    products_time_list(type){
      if(type==1){
        if(this.selected_products_time=='روزانه'){
          return this.dashboard_data.today_order_products
        }
        if(this.selected_products_time=='ماهانه'){
          return this.dashboard_data.month_order_products
        }
        if(this.selected_products_time=='سالانه'){
          return this.dashboard_data.all_order_products
        }
      }
      if(type==2){
        if(this.selected_products_time=='روزانه'){
          return this.dashboard_data.today_view_products
        }
        if(this.selected_products_time=='ماهانه'){
          return this.dashboard_data.month_view_products
        }
        if(this.selected_products_time=='سالانه'){
          return this.dashboard_data.all_view_products
        }
      }
    },
    get_dashboard_data() {
      var self = this;
      // console.log("route id "+this.$route.params.cat_id);
      var formData = new FormData();

      axios.post('/api/admin/dashboard_data', formData, {}).then(function (response) {

        var contents = response.data;

        self.dashboard_data = contents;

      })
          .catch(function (error) {
            console.log(error);
          });

    },
  }
}
</script>
